module.exports = "https://cdn2-fs.clearscore.com/flux/images/ab9b369c14c8877f77a4153183a76484.jpg";